$(document).ready(function(){
    var owl = $('.ny-presents__slider');
    owl.owlCarousel({
        autoplay: false,
        loop: false,
        nav: false,
        dots:false,
        items: 1,
        onInitialized  : counter, //When the plugin has initialized.
        onTranslated : counter //When the translation of the stage has
    });
    function counter(event) {
        var element   = event.target;
        var items     = event.item.count;
        var item      = event.item.index + 1;
        $('.ny-presents__slider_counter').html(" "+item+"  ")
    }

    // Custom Button
    $('.ny-presents__slider_next').click(function() {
        owl.trigger('next.owl.carousel');
    });
    $('.ny-presents__slider_prev').click(function() {
        owl.trigger('prev.owl.carousel');
    });

});
